import { useEffect } from 'react';
import { useFlagsmith } from 'flagsmith/react';
import { useRouter } from 'next/router';
import { AuthStore } from '@features/auth/domain/AuthStore';
import { flagValueToPathMap } from '@features/libs/flagValueToPathMap';
import { urls } from '@features/libs/urls';

const useRedirectWhenFullyRegistered = (authStore: AuthStore) => {
  const router = useRouter();
  const featureFlagsManager = useFlagsmith();

  const { query } = router;

  const registerRedirectFlagValue = featureFlagsManager.getValue(
    'saas_register_redirect_path'
  ) as string;
  const registerRedirectPath = flagValueToPathMap[registerRedirectFlagValue];

  useEffect(() => {
    if (authStore.isBusinessRegistered) {
      delete query.redirect;
      if (
        featureFlagsManager.hasFeature('saas_register_redirect_tax_service')
      ) {
        router.push(urls.taxCredentials);
      } else {
        router.push({ pathname: registerRedirectPath, query });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.isBusinessRegistered]);
};

export default useRedirectWhenFullyRegistered;
